require('svg-morpheus/compile/minified/svg-morpheus')

// Lodash
window._ = require('lodash')

// Moment with timezones
window.moment = require('moment-timezone')

// ProseMirror
require('@pluxbox/pbx-prosemirror')

// Jquery
window.jQuery = window.$ = require('jquery')
require('jquery-minicolors/jquery.minicolors.min')
require('jquery-ui/ui/widgets/draggable')
require('jquery-ui/ui/widgets/sortable')

// Ace
require('ace-builds/src-noconflict/ace')
require('ace-builds/src-noconflict/mode-twig')

// Angular
require('angular')
require('@uirouter/angularjs')
require('angular-sanitize')
require('angular-animate')
require('angular-aria')
require('angular-messages')
require('angular-material-icons')
require('angular-resource')
require('angular-ui-sortable')
require('angular-bowser')
require('angular-tree-control/context-menu')
require('angular-tree-control')
require('angular-payments')
require('angular-gravatar')
require('angular-cookies')
require('angular-utils-pagination')
require('angular-minicolors')
require('angular-drag-and-drop-lists')
require('angular-recaptcha')
require('angular-material')
require('ng-file-upload')
require('angular-ui-ace')

// Popper
window.PopperJs = require('@popperjs/core').default

// Yjs
window.Y = require('yjs')
Y.WebsocketProvider = require('y-websocket').WebsocketProvider
Y.ProseMirrorBinding = require('y-prosemirror')

ShadowRoot.prototype.createRange = document.createRange.bind(document)
